import { render } from "./Details.vue?vue&type=template&id=2300b4b1"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=2300b4b1&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__